import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=4b99759e&scoped=true"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"
import style0 from "./Term.vue?vue&type=style&index=0&id=4b99759e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99759e",
  null
  
)

export default component.exports